const error = (state = "", action) => {
  switch (action.type) {
    case "DISPLAY_ERROR":
      console.dir(action.error);
      if (action.error.message === "Failed to fetch")
        return "There was an issue processing your request.";
      return typeof action.error === "object" ? "" : action.error;
    default:
      return state;
  }
};

export default error;
